import { useState, useEffect } from "react";
import { Modal, Button, message, Tooltip } from "antd";
import { CopyOutlined } from "@ant-design/icons";
import "../less/_main-dir.less";
import config from "./../../../config";
import StoreService from "../../../services/api/RestaurantDetailService";

// ─── Services ─────────────────────────────────────────────────────────────────
const storeService = new StoreService();

const tooltipText = "Copy Code.";

const GenereateOrderNowView = (props: any) => {
  const [codeSnippet, setCodeSnippet] = useState("");
  const [storeSlug, setStreSlug] = useState("");

  // AP-5800: `store.slug` is assigned at registration — before Restaurant
  // Details (address, etc.) are ever filled in — so its presence alone doesn't
  // mean Restaurant Details is complete; checking `storeSlug` here let a fresh
  // account's brief loading flicker resolve into the fully-working snippet
  // anyway once the (always-present) slug loaded. Compute completeness
  // synchronously, the same way NewHeaderView's nav guard does, so nothing
  // flashes and the functional content is actually gated on it.
  const storObj = JSON.parse(localStorage.getItem("store") ?? "{}");
  const hasRestaurantDetails = !!(
    storObj?.address_1 &&
    storObj?.city &&
    storObj?.state &&
    storObj?.zip_code &&
    storObj?.country
  );

  useEffect(() => {
    const initialize = async () => {
      const storeID = storObj && storObj._id ? storObj._id : "";

      if (storeID && hasRestaurantDetails) {
        let slug = await storeService.getStoreSlug(storeID);
        setStreSlug(slug);
        if (!slug) return;
        let code = `
<container>
    <style type="text/css">
        .image {
            height: 30px; 
            padding-right: 8px;
        }
        .btn{
            background: #fdb415;
            color: #ffffff; 
            padding: 10px 12px; 
            font-weight: 600; 
            font-size: 16px; 
            text-decoration: none; 
            display: inline-flex;
            align-items: center;
            font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen','Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',sans-serif;
        }
        .btn:hover {
            background: #ffc83d;
        }
    </style>
    <a href="` + config.CUSTOMER_ENDPOINT + `restaurants/` + slug + `" target="_blank"; class="btn">
        <img src="` + config.LOGO + `" alt="Hard Liquors" class="image">
        Order Now
    </a>
</container>
        `;
        setCodeSnippet(code);
      }
    };
    initialize();
  }, []);

  const onCancel = () => {
    props.onCancel();
  };

  const onClickCopyToClipboard = () => {
    navigator.clipboard.writeText(codeSnippet);
    message.success("Copied!");
  };

  return (
    <div>
      <Modal
        forceRender
        title="Generate Order Now"
        open={props.visible}
        centered
        onCancel={onCancel}
        width={550}
        footer={false}
        mask={{ closable: false }}
      >
        {hasRestaurantDetails && storeSlug ? (
          <>
            <div className="flex_end">
              <Tooltip title={tooltipText} placement="topRight">
                <Button
                  htmlType="submit"
                  className="primary-btn font-size-24px padding-top-5px"
                  onClick={onClickCopyToClipboard}
                >
                  <CopyOutlined />
                </Button>
              </Tooltip>
            </div>
            <pre className="margin-top-66px" style={{ overflow: 'auto' }}>
              {codeSnippet}
            </pre>

            <div className="margin-top-20px font-width-600">Example Button View</div>
            <div className="generate_btn">
              <a
                href={config.CUSTOMER_ENDPOINT + `restaurants/` + storeSlug}
                target="_blank"
                rel="noreferrer"
                className="btn"
              >
                <img src={config.LOGO} alt="Hard Liquors" className="image" />
                Order Now
              </a>
            </div>
          </>
        ) : (
          // AP-5800: Restaurant Details incomplete (or slug not loaded yet) —
          // don't render the copyable snippet or the dead preview link. This
          // message now stays up for as long as the modal is open instead of
          // being replaced once the (always-present, registration-time) slug
          // loads.
          <div className="margin-top-20px">
            Please complete your Restaurant Details first to generate an order link.
          </div>
        )}
      </Modal>
    </div>
  );
};

export default GenereateOrderNowView;